import React from 'react'
import LicenseSelector from './licenseSelector'

class LicenseFixer extends React.Component {
	constructor(props) {
		super(props);
		this.initialState = {
			query: "",
			selected: "",
			initialLicenses: props.licenses ?? [],
			licenses: props.licenses ?? [],
			showErrorAlert: false,
			errorMessage: "",
			recompute: false,
			query: ""
		}
		this.state = {...JSON.parse(JSON.stringify(this.initialState))}
		this.errorMessages = {
			noLicense: "There are no licenses to add. Did you forget click on the '+' button?",
			dublicates: "License already exists",
			selectLicense: "Select a license to add "
		}
	}

	getLicenses = async (library) => {
		try {
			const licensesDbFormat = await window.meterian.licenses.getLicenses(library)
			const licenses = licensesDbFormat.map((license) => license.id)
			this.setState({...this.state, licenses, initialLicenses: licenses})
		} catch (e) {
			console.log(e)
			throw(e)
		}
	}
	onSelectionChange = (e) => {
		if (e.target.value === this.query) return;
		this.query = e.target.value;
		this.setState({ query: this.query })
	}

	removeLicense = (index) => {
		let licenses = [...this.state.licenses]
		licenses.splice(index, 1)
		this.setState({...this.state,licenses})
	}

	setSelected = (target) => {
		let value = target
		if(target && target.value) value = target.value
		this.setState({...this.state, selected: value})
	}

	addLicense = (e) => {
		if(!this.state.selected.length) {
			this.showErrorAlert(this.errorMessages.selectLicense)
			return
		} else if (this.state.licenses.includes(this.state.selected)) {
			this.showErrorAlert(this.errorMessages.dublicates)
			return
		} 
		let licenses = [...this.state.licenses, this.state.selected]
		this.setState({...this.state,licenses})
	}

	submitHandler = this.props.onSubmit ? this.props.onSubmit: async (licenses) => {
		const library = this.props.licenseToFix
		const initialLicenses = this.state.initialLicenses
		if(this.errorHandler()) return
		try {
			const currentLicenses = this.state.initialLicenses
			await this.deleteLicensesFromDb(licenses, initialLicenses, library)
			await this.addLicensesToDb(licenses, initialLicenses, library)
			const licensesDbFormat = await window.meterian.licenses.getLicenses(this.props.licenseToFix)
			const licenseToFix = this.props.licenseToFix
			window.$("#license-fix-dialog .modal-header > button").trigger("click")
			await this.props.fixLicense(this.props.licenseToFix,licensesDbFormat, this.state.recompute)
		} catch(e) {
			throw (e)
		}
	}

	errorHandler = () => {
		if(!this.state.licenses.length && !this.state.initialLicenses.length) {
			this.showErrorAlert(this.errorMessages.noLicense)
            return true
        }
        return false
	}

	showErrorAlert = (message) => {
		this.setState({...this.state, errorMessage: message, showErrorAlert: true})
		setTimeout(() => {
			this.hideErrorAlert()
		}, 5000)
	}
	
	hideErrorAlert = () => {
		this.setState({...this.state, errorMessage: "", showErrorAlert: false})
	}
	
	deleteLicensesFromDb = async (licensesToAdd, initialLicenses, library) => {
		for(let i = 0; i < initialLicenses.length; i++) {
			if(!licensesToAdd.includes(initialLicenses[i])) {
				await window.meterian.licenses.deleteLicense(library, initialLicenses[i])
			}
		}
	}

	addLicensesToDb = async (licensesToAdd, initialLicenses, library) => {
		for(let i = 0; i < licensesToAdd.length; i++) {
			const licenseToAdd = licensesToAdd[i]
			if(!initialLicenses.includes(licenseToAdd)) {
				await window.meterian.licenses.addLicense(library, licenseToAdd)
			}
		}
	}

	recumputeIsDisabled = () => {
		if(!this.state.initialLicenses.length && !this.state.licenses.length) return true
		return false
	}

	getSnapshotBeforeUpdate(previousProps) {
        return previousProps.licenseToFix !== this.props.licenseToFix
    }

    componentDidUpdate(prevProps,prevState,didUpdate){
        if ( ! didUpdate ) return
		this.setState({...JSON.parse(JSON.stringify(this.initialState))})
		if(Object.keys(this.props.licenseToFix).length) this.getLicenses(this.props.licenseToFix)
		window.$("#license-fix-dialog").off("hidden.bs.modal").on("hidden.bs.modal",()=>{
			this.props.setLicenseToFix()
			this.setState({...JSON.parse(JSON.stringify(this.initialState))})
		})
    }


	render() {
		const { licenseToFix } = this.props;
		return (
			<div className="modal fade" id="license-fix-dialog" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						
						<div id="alert-modal" style={{ display: 'none' }}>
							<br />
							<div className="alert alert-danger">
								<strong><span id="alert-modal-message"></span></strong>
								<span href="#" className="close" data-hide="alert">&times;</span>
							</div>
						</div>

						<div className="modal-header">
							<h4 className="modal-title" id="license-fix-title">{licenseToFix.title}</h4>
							<button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
						</div>

						<div className="modal-body">
							{this.state.licenses.length ? <div className='license-badge-container'>
								{this.state.licenses.map((license, index) => {
									return <div key={`${index}-license`} className='license-badge badge-light'>
										<span data-testid="license-name">{license}</span>
										<span className="license-remove-badge" data-index={index} data-testid="remove-license" onClick={() => this.removeLicense(index)}>&times;</span>
									</div>
								})}
							</div>: ""
							}
							<div role="form" onKeyUp={this.onSelectionChange}>
								<strong>Select the license:</strong>
								<div className="form-horizontal">
									<div className='license-fixer-select-container'>						
										<LicenseSelector query={this.state.query} setSelected={this.setSelected} licenseToFix={licenseToFix}/>
										<i className="fas fa-plus add-license-btn" style={{color: "var(--color-primary-1)"}} onClick={this.addLicense}></i>
										{/* <i className="fas fa-plus-square add-license-btn" onClick={this.addLicense}></i> */}
									</div>
									<input type="checkbox" id="recumpute-checkbox" data-testid="recumpute-checkbox" disabled={this.recumputeIsDisabled()} onChange={(e) => this.setState({...this.state, recompute: !this.state.recompute})} checked={this.state.recompute}></input>
									<label htmlFor="recumpute-checkbox" style={{marginLeft: "5px"}}>Automatically recompute the report</label>
								</div>
							</div>
							{this.state.showErrorAlert ? 
                                    <div id="alert-modal">
                                        <div className="alert alert-danger">
                                            <strong><span id="alert-modal-message" data-testid="error-message">{this.state.errorMessage}</span></strong>
                                            <button href="#" className="close" data-hide="alert" data-testid="close-error-message" onClick={this.hideErrorAlert} style={{pointerEvents: "all"}}>&times;</button>
                                        </div>
                                    </div>: ""
                                }
						</div>
						
						<div className="modal-footer">
							<button type="button" className="btn btn-default" data-dismiss="modal">Cancel</button>
							<button type="button" className="btn btn-primary" data-testid="form-submit" onClick={() => this.submitHandler(this.state.licenses)} >Confirm</button>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


export default LicenseFixer